import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { parseHeader, getHeaderHtml } from '../../../util/headerUtil';

const HeaderPreviewModal = ({ show, onHide, hospitalData }) => {

    const renderTemplate = () => {
        // Use provided hospitalData for getHeaderHtml
        const actualData = {
            ...hospitalData,
            PrescHeader: true // Always show in preview
        };

        return <div dangerouslySetInnerHTML={{ __html: getHeaderHtml(actualData) }} />;
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton closeVariant="white" style={{ background: 'var(--primary-color)', color: 'white' }}>
                <Modal.Title style={{ color: 'white' }}>Header Template {hospitalData?.selectHeader} Preview</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '40px', background: '#fcfcfc' }}>
                <div style={{ background: 'white', boxShadow: '0 10px 30px rgba(0,0,0,0.08)', borderRadius: '10px', padding: '10px' }}>
                    {renderTemplate()}
                </div>
                <div style={{ marginTop: '30px', padding: '15px', background: 'var(--light-color)', borderRadius: '8px', fontSize: '0.85rem', color: 'var(--primary-color)' }}>
                    <strong>Note:</strong> This preview uses the content from the "Set Prescription Header" field.
                    Lines are split by new line: Line 1 = Hospital Name, Line 2 = Doctor Name/Degree, Remaining lines = Other Info.
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default HeaderPreviewModal;
